export default class CampBookingForm {
    constructor($form) {
        this.$form = $form;
        this.$periodSelect = $form.querySelector('[data-camp-period-select]');
        this.$periodSummary = $form.querySelector('[data-camp-period-summary]');
        this.$childSelect = $form.querySelector('[data-camp-child-select]');
        this.$childFields = {
            firstName: $form.querySelector('[data-camp-child-field="firstName"]'),
            lastName: $form.querySelector('[data-camp-child-field="lastName"]'),
            birthDate: $form.querySelector('[data-camp-child-field="birthDate"]'),
            gender: $form.querySelector('[data-camp-child-field="gender"]'),
            extraInfo: $form.querySelector('[data-camp-child-field="extraInfo"]'),
        };

        if (this.$periodSelect) {
            this.$periodSelect.addEventListener('change', () => this.applyPeriodSelection());
            this.applyPeriodSelection();
        }

        if (this.$childSelect) {
            this.$childSelect.addEventListener('change', () => this.applyChildSelection(true));
            this.applyChildSelection(false);
        }
    }

    applyPeriodSelection() {
        if (!this.$periodSelect || !this.$periodSummary) {
            return;
        }

        const $option = this.$periodSelect.selectedOptions[0] || null;
        const summary = $option ? ($option.dataset.summary || $option.textContent.trim()) : '';

        this.$periodSummary.textContent = summary;
        this.$periodSelect.title = summary;
    }

    applyChildSelection(clearWhenEmpty = false) {
        const $option = this.$childSelect.selectedOptions[0] || null;
        const hasChild = $option !== null && this.$childSelect.value !== '';

        if (!hasChild) {
            if (clearWhenEmpty) {
                this.clearFields();
            }
            this.setReadOnly(false);
            return;
        }

        this.setField('firstName', $option.dataset.firstName || '', true);
        this.setField('lastName', $option.dataset.lastName || '', true);
        this.setField('birthDate', $option.dataset.birthDate || '', true);
        this.setField('gender', $option.dataset.gender || '', true);
        this.setField('extraInfo', $option.dataset.extraInfo || '', true);
    }

    clearFields() {
        Object.keys(this.$childFields).forEach((field) => this.setField(field, '', false));
    }

    setReadOnly(isReadOnly) {
        Object.keys(this.$childFields).forEach((field) => {
            this.setField(field, this.$childFields[field] ? this.$childFields[field].value : '', isReadOnly);
        });
    }

    setField(name, value, isReadOnly) {
        const $field = this.$childFields[name];
        if (!$field) {
            return;
        }

        $field.value = value;
        if ($field.tagName === 'SELECT') {
            $field.disabled = isReadOnly;
            return;
        }

        $field.readOnly = isReadOnly;
    }
}
